import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getProject } from '../services/api';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { slug } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const data = await getProject(slug);
        setProject(data);
        setActiveImage(data.featured_image_url);
      } catch (error) {
        console.error('Error fetching project:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [slug]);

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!project) {
    return <div className="not-found">Project not found</div>;
  }

  const allImages = [
    project.featured_image_url,
    project.before_image_url,
    project.after_image_url,
    ...(project.images || []).map(img => img.image_url)
  ].filter(Boolean);

  return (
    <div className="project-detail-page">
      <div className="project-hero" style={{ backgroundImage: `url(${project.featured_image_url})` }}>
        <div className="project-hero-overlay"></div>
        <div className="project-hero-content">
          <div className="container">
            <Link to="/portfolio" className="back-link">← Back to Portfolio</Link>
            <h1>{project.title}</h1>
            {project.client_name && <p className="project-client">{project.client_name}</p>}
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          <div className="project-content">
            <div className="project-gallery">
              <div className="main-image">
                <img src={activeImage} alt={project.title} />
              </div>
              {allImages.length > 1 && (
                <div className="thumbnail-strip">
                  {allImages.map((img, i) => (
                    <button 
                      key={i}
                      className={`thumbnail ${activeImage === img ? 'active' : ''}`}
                      onClick={() => setActiveImage(img)}
                    >
                      <img src={img} alt={`${project.title} ${i + 1}`} />
                    </button>
                  ))}
                </div>
              )}

              {project.before_image_url && project.after_image_url && (
                <div className="before-after">
                  <div className="ba-item">
                    <span className="ba-label">Before</span>
                    <img src={project.before_image_url} alt="Before" />
                  </div>
                  <div className="ba-item">
                    <span className="ba-label">After</span>
                    <img src={project.after_image_url} alt="After" />
                  </div>
                </div>
              )}
            </div>

            <div className="project-details">
              <div className="project-meta">
                {project.location && (
                  <div className="meta-item">
                    <span className="meta-label">Location</span>
                    <span className="meta-value">{project.location}</span>
                  </div>
                )}
                {project.project_date && (
                  <div className="meta-item">
                    <span className="meta-label">Completed</span>
                    <span className="meta-value">{new Date(project.project_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</span>
                  </div>
                )}
              </div>

              {project.services_provided && project.services_provided.length > 0 && (
                <div className="project-services">
                  <h3>Services Provided</h3>
                  <div className="services-tags">
                    {project.services_provided.map((service, i) => (
                      <span key={i} className="service-tag">{service}</span>
                    ))}
                  </div>
                </div>
              )}

              <div className="project-description">
                <h3>About This Project</h3>
                <p>{project.full_description || project.short_description}</p>
              </div>

              <div className="project-cta">
                <h3>Interested in a Similar Project?</h3>
                <Link to="/contact" className="btn btn-primary">Get a Quote</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectDetail;
